import parse from "html-react-parser";

type Props = {
  htmlString: string;
};

const ParsedHtml = ({ htmlString }: Props) => {
  const handleElement = (node: any) => {
    if (node.type === "tag" && node.name === "head") {
      // Get all style elements
      const styles = node.children.filter((child: any) => child.type === "tag" && child.name === "style");
      // Combine all CSS text into one string
      const cssText = styles.map((style: any) => style.children[0].data).join("");
      // Apply styles to target element
      const target = document.getElementsByClassName("inserted-html")[0];
      target?.setAttribute("style", cssText);
    }
  };

  const handleComment = () => {
    return "";
    // Ignore comments
  };

  const handleText = (node: any) => {
    return node;
    // Ignore text nodes
  };

  const handleNode = (node: any) => {
    switch (node.type) {
      case "tag":
        handleElement(node);
        break;
      case "comment":
        handleComment();
        break;
      case "text":
        handleText(node);
        break;
      default:
        break;
    }
  };

  const handleHtmlString = (htmlString: string) => {
    return parse(htmlString, {
      replace: (node: any) => {
        handleNode(node);
        return undefined;
      },
    });
  };

  return (
    <div className="inserted-html">{handleHtmlString(htmlString.replace("<html>", "").replace("</html>", ""))}</div>
  );
};

export default ParsedHtml;
